import { helpers } 		from './sites/helpers.js';

window.sitesExtendedPremium = {
	globals: {},

	init: function () {
		var self = this;
		self.tabs();
	},

	tabs: function () {
		jQuery('.tabs__nav a, .tabs-wsw__nav div').on('click', function (e) {
			e.preventDefault();
			
			jQuery( this ).closest( '.js-tabs' ).find( '.active' ).removeClass( 'active' );

			var newActiveTab = jQuery( this ).data( 'href' );
			jQuery( this ).parent().addClass( 'active' );
			jQuery( this ).closest( '.js-tabs' ).find( '[data-name="'+ newActiveTab +'"]' ).addClass( 'active' );
        });
	},

	onresize() {
		var self = this;
	},

	onscroll(position, previusPosition) {
		var self = this;
	},
};

jQuery(document).ready(function ($) {
	sitesExtendedPremium.init();
});

window.addEventListener('scroll', function (e) {
	sitesExtendedPremium.onscroll();
});

window.addEventListener('resize', function (e) {
	sitesExtendedPremium.onresize();
});